var map = {
	"./QQ.svg": "a44a",
	"./bg-img-yellow.svg": "7a35",
	"./camera-1.svg": "422c",
	"./camera-actived.svg": "cd48",
	"./camera-yellow.svg": "0d17",
	"./camera.svg": "8ce0",
	"./home-actived.svg": "deda",
	"./home.svg": "6bbe",
	"./location.svg": "1c50",
	"./square.svg": "b0c2",
	"./user-center-actived.svg": "1e8f",
	"./user-center.svg": "e69d",
	"./wechat.svg": "80da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";